/*eslint-disable no-undef */
import phina from 'phina.js'

export default ()=>{
/**
 * 動かないカウンター
 */
phina.define("BaseCounter", {
    superClass: "phina.display.Shape",
    init: function(param){
        param = (param||{}).$safe(BaseCounter.defaults);
        // var self = this;
        this.superInit(param);
    },
    colorStringToIndex: function(color){
        if(color.toLowerCase() == 'n'){
            return 0;
        }else if(color.toLowerCase() == 'a'){
            return 0;
        }else if(color.toLowerCase() == 'h'){
            return 10;
        }else if(color.toLowerCase() == 'r'){
            return 20;
        }else if(color.toLowerCase() == 'b'){
            return 30;
        }else if(color.toLowerCase() == 'y'){
            return 40;
        }else if(color.toLowerCase() == 'g'){
            return 50;
        }else if(color.toLowerCase() == 's'){
            return 60;
        }else if(color.toLowerCase() == 'd'){
            return 70;
        }else if(color.toLowerCase() == 'w'){
            return 80;
        }else if(color.toLowerCase() == 'm'){
            return 90;
        }else{
            return 0;
        }
    },
    _static: {
        defaults:{
            value: 0,
            // digitFont: march.display.CounterDigit,
            fill: 'transparent',
            stroke: 'transparent',
            backgroundColor: 'transparent',
            digitStyle: 'n',
        }
    }
});

/**
 * 動かないカウンター
 */
phina.define("DebugCounter", {
    superClass: "BaseCounter",
    init: function(param){
        param = (param||{}).$safe(DebugCounter.defaults);
        var self = this;
        this.superInit(param);
        this._value = param.value;
        var k=!param.value*1 || Math.floor(Math.LOG10E*Math.log(param.value))+1 || 1;
        var n=param.value;
        this.gridX = phina.util.Grid({
            width: param.digitWidth*k,
            //width: param.digitFont.width*k,
            columns: k,
        });
        for(var i=0;i<k;i++){
            //var d = {}.$extend(param.digitFont);
            var d = phina.display.CounterDigit({
                image: param.digitFont,
                width: param.digitWidth,
                height: param.digitHeight
            });
            d.setFrameIndex(n%10+self.colorStringToIndex(param.digitStyle));
            d.setPosition(this.gridX.span(k-i-1), 0);
            n=Math.floor(n/10);
            d.addChildTo(this);
        }
        this.tweener
//        .by({y:80},1000,"easeOutBounce")
        .wait(1000)
        .call(function(){ this.remove(); }.bind(this));
    },
    _static: {
        defaults:{
            value: 0,
            // digitFont: march.display.CounterDigit,
            fill: 'transparent',
            stroke: 'transparent',
            backgroundColor: 'transparent',
        }
    }
});

phina.define("SmashCounter", {
    superClass: "BaseCounter",
    init: function(param){
        param = (param||{}).$safe(SmashCounter.defaults);
        var self = this;
        this.superInit(param);
        this._value = param.value;
        var k=!param.value*1 || Math.floor(Math.LOG10E*Math.log(param.value))+1 || 1;
        var n=param.value;
        this.gridX = phina.util.Grid({
            width: param.digitWidth*k,
            //width: param.digitFont.width*k,
            columns: k,
        });
        var dx = Math.randint(-200,200);
        for(var i=0;i<k;i++){
            //var d = {}.$extend(param.digitFont);
            // var d = 
            phina.display.CounterDigit({
                image: param.digitFont,
                width: param.digitWidth,
                height: param.digitHeight
            })
            .setFrameIndex(n%10+self.colorStringToIndex(param.digitStyle))
            .setPosition(this.gridX.span(k-i-1), 0)
            .addChildTo(this)
            .tweener
              .moveBy(dx,0, 1000);
            n=Math.floor(n/10);
        }
        this.tweener
        .moveBy(0,-Math.randint(70,100), 500,"easeOutCubic")
        .moveBy(0,300, 500,"easeInCubic")
        .call(function(){ this.remove(); }.bind(this));
    },
    _static: {
        defaults:{
            value: 0,
            // digitFont: march.display.CounterDigit,
            fill: 'transparent',
            stroke: 'transparent',
            backgroundColor: 'transparent',
        }
    }
});

phina.define("SlashCounter", {
    superClass: "BaseCounter",
    init: function(param){
        param = (param||{}).$safe(SmashCounter.defaults);
        var self = this;
        this.superInit(param);
        this._value = param.value;
        var k=!param.value*1 || Math.floor(Math.LOG10E*Math.log(param.value))+1 || 1;
        var n=param.value;
        this.gridX = phina.util.Grid({
            width: param.digitWidth*k,
            //width: param.digitFont.width*k,
            columns: k,
        });
        // var dx = Math.randint(-200,200);
        for(var i=0;i<k;i++){
            //var d = {}.$extend(param.digitFont);
            // var d = 
            phina.display.CounterDigit({
                image: param.digitFont,
                width: param.digitWidth,
                height: param.digitHeight
            })
            .setFrameIndex(n%10+self.colorStringToIndex(param.digitStyle))
            .setPosition(this.gridX.span(k-i-1), 0)
            .addChildTo(this);
            n=Math.floor(n/10);
        }
        this.tweener
        .moveBy(0,-75, 500,"easeOutCubic")
        .wait(500)
        .call(function(){ this.remove(); }.bind(this));
    },
    _static: {
        defaults:{
            value: 0,
            // digitFont: march.display.CounterDigit,
            fill: 'transparent',
            stroke: 'transparent',
            backgroundColor: 'transparent',
        }
    }
});

phina.define("ThrustCounter", {
    superClass: "BaseCounter",
    init: function(param){
        param = (param||{}).$safe(SmashCounter.defaults);
        var self = this;
        this.superInit(param);
        this._value = param.value;
        var k=!param.value*1 || Math.floor(Math.LOG10E*Math.log(param.value))+1 || 1;
        var n=param.value;
        this.gridX = phina.util.Grid({
            width: param.digitWidth*k,
            //width: param.digitFont.width*k,
            columns: k,
        });
        // var dx = Math.randint(-200,200);
        for(var i=0;i<k;i++){
            //var d = {}.$extend(param.digitFont);
            // var d = 
            phina.display.CounterDigit({
                image: param.digitFont,
                width: param.digitWidth,
                height: param.digitHeight
            })
            .setFrameIndex(n%10+self.colorStringToIndex(param.digitStyle))
            .setPosition(this.gridX.span(k-i-1), 0)
            .addChildTo(this)
            .tweener
              .to({scaleX:1.5,scaleY:1.5,x:this.gridX.span(k-i-1)+(k-i-1-k/2)*param.digitWidth/4},200,'easeInSine')
              .to({scaleX:1.0,scaleY:1.0,x:this.gridX.span(k-i-1)},100,'easeOutSine');
            n=Math.floor(n/10);
        }
        this.tweener
        .wait(1000)
        .call(function(){ this.remove(); }.bind(this));
    },
    _static: {
        defaults:{
            value: 0,
            // digitFont: march.display.CounterDigit,
            fill: 'transparent',
            stroke: 'transparent',
            backgroundColor: 'transparent',
        }
    }
});

phina.define("ShockCounter", {
    superClass: "BaseCounter",
    init: function(param){
        param = (param||{}).$safe(SmashCounter.defaults);
        var self = this;
        this.superInit(param);
        this._value = param.value;
        var k=!param.value*1 || Math.floor(Math.LOG10E*Math.log(param.value))+1 || 1;
        var n=param.value;
        this.gridX = phina.util.Grid({
            width: param.digitWidth*k,
            //width: param.digitFont.width*k,
            columns: k,
        });
        // var dx = Math.randint(-200,200);
        for(var i=0;i<k;i++){
            //var d = {}.$extend(param.digitFont);
            // var d = 
            phina.display.CounterDigit({
                image: param.digitFont,
                width: param.digitWidth,
                height: param.digitHeight
            })
            .setFrameIndex(n%10+self.colorStringToIndex(param.digitStyle))
            .setPosition(this.gridX.span(k-i-1), 0)
            .addChildTo(this);
            n=Math.floor(n/10);
        }
        this.on('added',function(){
            self.motox=self.x; self.motoy=self.y;
            this.tweener
            .wait(50)
            .moveTo(self.x+Math.randint(-20,0),self.y+Math.randint(-20,0),1)
            .wait(50)
            .moveTo(self.x+Math.randint(0,20),self.y+Math.randint(0,20),1)
            .wait(25)
            .moveTo(self.x+Math.randint(-15,0),self.y+Math.randint(-15,0),1)
            .wait(25)
            .moveTo(self.x+Math.randint(0,10),self.y+Math.randint(0,10),1)
            .wait(25)
            .moveTo(self.x+Math.randint(-5,5),self.y+Math.randint(-5,5),1)
            .wait(25)
            .moveTo(self.motox, self.motoy, 1)
            .wait(900)
            .call(function(){ this.remove(); }.bind(this));
        });
    },
    _static: {
        defaults:{
            value: 0,
            // digitFont: march.display.CounterDigit,
            fill: 'transparent',
            stroke: 'transparent',
            backgroundColor: 'transparent',
        }
    }
});

phina.define("BlessCounter", {
    superClass: "BaseCounter",
    init: function(param){
        param = (param||{}).$safe(SmashCounter.defaults);
        var self = this;
        this.superInit(param);
        this._value = param.value;
        var k=!param.value*1 || Math.floor(Math.LOG10E*Math.log(param.value))+1 || 1;
        var n=param.value;
        this.gridX = phina.util.Grid({
            width: param.digitWidth*k,
            //width: param.digitFont.width*k,
            columns: k,
        });
        var dx = Math.randint(0,200)*param.direction;
        for(var i=0;i<k;i++){
            //var d = {}.$extend(param.digitFont);
            // var d = 
            phina.display.CounterDigit({
                image: param.digitFont,
                width: param.digitWidth,
                height: param.digitHeight
            })
            .setFrameIndex(n%10+self.colorStringToIndex(param.digitStyle))
            .setPosition(this.gridX.span(k-i-1), 0)
            .addChildTo(this)
            .tweener
              .moveBy(dx,0, 1000);
            n=Math.floor(n/10);
        }
        this.tweener
        .moveBy(0,-Math.randint(70,100), 500,"easeOutCubic")
        .moveBy(0,300, 500,"easeInCubic")
        .call(function(){ this.remove(); }.bind(this));
    },
    _static: {
        defaults:{
            value: 0,
            // digitFont: march.display.CounterDigit,
            fill: 'transparent',
            stroke: 'transparent',
            backgroundColor: 'transparent',
            direction: 1,
        }
    }
});

}